import AdministrationEntries from "../docs-archive-elements/AdministrationEntries";
import BudgetsEntries from "../docs-archive-elements/BudgetsEntries";
import CodeEnforcementEntries from "../docs-archive-elements/CodeEnforcementEntries";
import Council2016Entries from "../docs-archive-elements/Council2016Entries";
import Council2017Entries from "../docs-archive-elements/Council2017Entries";
import Council2018Entries from "../docs-archive-elements/Council2018Entries";
import Council2019Entries from "../docs-archive-elements/Council2019Entries";
import Council2020Entries from "../docs-archive-elements/Council2020Entries";
import Council2021Entries from "../docs-archive-elements/Council2021Entries";
import Council2022Entries from "../docs-archive-elements/Council2022Entries";
import Council2023Entries from "../docs-archive-elements/Council2023Entries";
import Council2024Entries from "../docs-archive-elements/Council2024Entries";
import Council2025Entries from "../docs-archive-elements/Council2025Entries";
import Council2026Entries from "../docs-archive-elements/Council2026Entries";
import CouncilRelatedEntries from "../docs-archive-elements/CouncilRelatedEntries";
import EACEntries from "../docs-archive-elements/EACEntries";
import EventFlyersEntries from "../docs-archive-elements/EventFlyersEntries";
import InfoEntries from "../docs-archive-elements/InfoEntries";
import NewslettersEntries from "../docs-archive-elements/NewslettersEntries";
import NoticesEntries from "../docs-archive-elements/NoticesEntries";
import PCEntries from "../docs-archive-elements/PCEntries";
import PressReleaseEntries from "../docs-archive-elements/PressReleaseEntries";
import RoadProgramEntries from "../docs-archive-elements/RoadProgramEntries";
import SanitationEntries from "../docs-archive-elements/SanitationEntries";
import StormwaterEntries from "../docs-archive-elements/StormwaterEntries";
import ZHBEntries from "../docs-archive-elements/ZHBEntries";

export default function DocsDetails() {
  return (
    <div>
      <div className="trees-bg bg-image">
        <div className="gap-spacer"></div>
        <div className="page-title top-cap-outlines">
          <h2>Document Archive</h2>
        </div>
        {/*Start Main Content*/}
        <div className="content-fluid">
          {/*Start Center Container*/}
          <div className="mb-960-center-container mid-side-outlines">
            {/*Start Left Side Of Page*/}
            <div className="mb-960-col-50p">
              <br />

              {/* Accordion Start - Administration */}
              <div className="container accordion-container doc-accordion">
                <div className="accordion" id="AdminDocsAccordion">
                  {/* Item Start */}
                  <div className="stacked-accordion">
                    <h2 className="accordion-header">
                      <button className="accordion-button caret-off collapsed bgwhite-textblack-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapseAdminDocs">
                        <div className="archivebox"></div>
                        <div>
                          <b className="accordion-title">Administration</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapseAdminDocs" className="accordion-collapse collapse" data-bs-parent="#AdminDocsAccordion">
                      <div className="accordion-body-no-sides">
                        <AdministrationEntries />
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                </div>
              </div>
              {/* Accordion Finish - Administration */}

              {/*Accordion Start - Borough Coucil Docs */}
              <div className="container accordion-container doc-accordion">
                <div className="accordion" id="CoucilDocsAccordion">
                  {/* Item Start  - COUNCIL OVERALL*/}
                  <div className="stacked-accordion">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button caret-off collapsed bgwhite-textblack-item button-full-width"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseCouncilOverall"
                      >
                        <div className="archivebox"></div>
                        <div>
                          <b className="accordion-title">Borough Council</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapseCouncilOverall" className="accordion-collapse collapse" data-bs-parent="CoucilDocsAccordion">
                      <div className="accordion-body-no-sides">
                        {/*START OF AGENDAS & MEETING DOCS BY YEAR*/}
                         {/* Item Start  - COUNCIL RELATED */}
                        <div className="stacked-accordion">
                          <h2 className="accordion-header">
                            <button
                              className="accordion-button caret-off collapsed bgwhite-textblack-item button-full-width"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseCouncilRelated"
                            >
                              <div className="archivebox"></div>
                              <div>
                                <b className="accordion-title">Council Related Documents</b>
                              </div>
                            </button>
                          </h2>
                          <div id="collapseCouncilRelated" className="accordion-collapse collapse" data-bs-parent="CoucilDocsAccordion">
                            <div className="accordion-body-no-sides">
                              <CouncilRelatedEntries />
                            </div>
                          </div>
                        </div>
                        {/* Item Finish - 2026 A&M*/}
                               {/* Item Start  - 2026 A&M*/}
                        <div className="stacked-accordion">
                          <h2 className="accordion-header">
                            <button
                              className="accordion-button caret-off collapsed bgwhite-textblack-item button-full-width"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse2026CoucilDocs"
                            >
                              <div className="archivebox"></div>
                              <div>
                                <b className="accordion-title">2026 Agendas &amp; Minutes</b>
                              </div>
                            </button>
                          </h2>
                          <div id="collapse2026CoucilDocs" className="accordion-collapse collapse" data-bs-parent="CoucilDocsAccordion">
                            <div className="accordion-body-no-sides">
                              <Council2026Entries />
                            </div>
                          </div>
                        </div>
                        {/* Item Finish - 2026 A&M*/}
                        {/* Item Start  - 2025 A&M*/}
                        <div className="stacked-accordion">
                          <h2 className="accordion-header">
                            <button
                              className="accordion-button caret-off collapsed bgwhite-textblack-item button-full-width"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse2025CoucilDocs"
                            >
                              <div className="archivebox"></div>
                              <div>
                                <b className="accordion-title">2025 Agendas &amp; Minutes</b>
                              </div>
                            </button>
                          </h2>
                          <div id="collapse2025CoucilDocs" className="accordion-collapse collapse" data-bs-parent="CoucilDocsAccordion">
                            <div className="accordion-body-no-sides">
                              <Council2025Entries />
                            </div>
                          </div>
                        </div>
                        {/* Item Finish - 2025 A&M*/}
                        {/* Item Start - 2024 A&M*/}
                        <div className="stacked-accordion">
                          <h2 className="accordion-header">
                            <button
                              className="accordion-button caret-off collapsed bgwhite-textblack-item button-full-width"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse2024CoucilDocs"
                            >
                              <div className="archivebox"></div>
                              <div>
                                <b className="accordion-title">2024 Agendas &amp; Minutes</b>
                              </div>
                            </button>
                          </h2>
                          <div id="collapse2024CoucilDocs" className="accordion-collapse collapse" data-bs-parent="CoucilDocsAccordion">
                            <div className="accordion-body-no-sides">
                              <Council2024Entries />
                            </div>
                          </div>
                        </div>
                        {/* Item Finish - 2024 A&M */}
                        {/* Item Start - 2023 A&M*/}
                        <div className="stacked-accordion">
                          <h2 className="accordion-header">
                            <button
                              className="accordion-button caret-off collapsed bgwhite-textblack-item button-full-width"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse2023CoucilDocs"
                            >
                              <div className="archivebox"></div>
                              <div>
                                <b className="accordion-title">2023 Agendas &amp; Minutes</b>
                              </div>
                            </button>
                          </h2>
                          <div id="collapse2023CoucilDocs" className="accordion-collapse collapse" data-bs-parent="CoucilDocsAccordion">
                            <div className="accordion-body-no-sides">
                              <Council2023Entries />
                            </div>
                          </div>
                        </div>
                        {/* Item Finish - 2023 A&M */}
                        {/* Item Start - 2022 A&M*/}
                        <div className="stacked-accordion">
                          <h2 className="accordion-header">
                            <button
                              className="accordion-button caret-off collapsed bgwhite-textblack-item button-full-width"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse2022CoucilDocs"
                            >
                              <div className="archivebox"></div>
                              <div>
                                <b className="accordion-title">2022 Agendas &amp; Minutes</b>
                              </div>
                            </button>
                          </h2>
                          <div id="collapse2022CoucilDocs" className="accordion-collapse collapse" data-bs-parent="CoucilDocsAccordion">
                            <div className="accordion-body-no-sides">
                              <Council2022Entries />
                            </div>
                          </div>
                        </div>
                        {/* Item Finish - 2022 A&M */}
                        {/* Item Start - 2021 A&M*/}
                        <div className="stacked-accordion">
                          <h2 className="accordion-header">
                            <button
                              className="accordion-button caret-off collapsed bgwhite-textblack-item button-full-width"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse2021CoucilDocs"
                            >
                              <div className="archivebox"></div>
                              <div>
                                <b className="accordion-title">2021 Agendas &amp; Minutes</b>
                              </div>
                            </button>
                          </h2>
                          <div id="collapse2021CoucilDocs" className="accordion-collapse collapse" data-bs-parent="CoucilDocsAccordion">
                            <div className="accordion-body-no-sides">
                              <Council2021Entries />
                            </div>
                          </div>
                        </div>
                        {/* Item Finish - 2021 A&M */}
                        {/* Item Start - 2020 A&M*/}
                        <div className="stacked-accordion">
                          <h2 className="accordion-header">
                            <button
                              className="accordion-button caret-off collapsed bgwhite-textblack-item button-full-width"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse2020CoucilDocs"
                            >
                              <div className="archivebox"></div>
                              <div>
                                <b className="accordion-title">2020 Agendas &amp; Minutes</b>
                              </div>
                            </button>
                          </h2>
                          <div id="collapse2020CoucilDocs" className="accordion-collapse collapse" data-bs-parent="CoucilDocsAccordion">
                            <div className="accordion-body-no-sides">
                              <Council2020Entries />
                            </div>
                          </div>
                        </div>
                        {/* Item Finish - 2020 A&M */}
                        {/* Item Start - 2019 A&M*/}
                        <div className="stacked-accordion">
                          <h2 className="accordion-header">
                            <button
                              className="accordion-button caret-off collapsed bgwhite-textblack-item button-full-width"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse2019CoucilDocs"
                            >
                              <div className="archivebox"></div>
                              <div>
                                <b className="accordion-title">2019 Agendas &amp; Minutes</b>
                              </div>
                            </button>
                          </h2>
                          <div id="collapse2019CoucilDocs" className="accordion-collapse collapse" data-bs-parent="CoucilDocsAccordion">
                            <div className="accordion-body-no-sides">
                              <Council2019Entries />
                            </div>
                          </div>
                        </div>
                        {/* Item Finish - 2019 A&M */}
                        {/* Item Start - 2018 A&M*/}
                        <div className="stacked-accordion">
                          <h2 className="accordion-header">
                            <button
                              className="accordion-button caret-off collapsed bgwhite-textblack-item button-full-width"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse2018CoucilDocs"
                            >
                              <div className="archivebox"></div>
                              <div>
                                <b className="accordion-title">2018 Agendas &amp; Minutes</b>
                              </div>
                            </button>
                          </h2>
                          <div id="collapse2018CoucilDocs" className="accordion-collapse collapse" data-bs-parent="CoucilDocsAccordion">
                            <div className="accordion-body-no-sides">
                              <Council2018Entries />
                            </div>
                          </div>
                        </div>
                        {/* Item Finish - 2018 A&M */}
                        {/* Item Start - 2017 A&M*/}
                        <div className="stacked-accordion">
                          <h2 className="accordion-header">
                            <button
                              className="accordion-button caret-off collapsed bgwhite-textblack-item button-full-width"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse2017CoucilDocs"
                            >
                              <div className="archivebox"></div>
                              <div>
                                <b className="accordion-title">2017 Agendas &amp; Minutes</b>
                              </div>
                            </button>
                          </h2>
                          <div id="collapse2017CoucilDocs" className="accordion-collapse collapse" data-bs-parent="CoucilDocsAccordion">
                            <div className="accordion-body-no-sides">
                              <Council2017Entries />
                            </div>
                          </div>
                        </div>
                        {/* Item Finish - 2017 A&M */}
                        {/* Item Start - 2016 A&M*/}
                        <div className="stacked-accordion">
                          <h2 className="accordion-header">
                            <button
                              className="accordion-button caret-off collapsed bgwhite-textblack-item button-full-width"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse2016CoucilDocs"
                            >
                              <div className="archivebox"></div>
                              <div>
                                <b className="accordion-title">2016 Agendas &amp; Minutes</b>
                              </div>
                            </button>
                          </h2>
                          <div id="collapse2016CoucilDocs" className="accordion-collapse collapse" data-bs-parent="CoucilDocsAccordion">
                            <div className="accordion-body-no-sides">
                              <Council2016Entries />
                            </div>
                          </div>
                        </div>
                        {/* Item Finish - 2016 A&M */}
                        {/*END OF AGENDAS & MEETING DOCS BY YEAR*/}
                      </div>
                    </div>
                  </div>
                  {/* Item Finish - COUNCIL OVERALL*/}
                </div>
              </div>
              {/* Accordion Finish - Borough Council Docs */}

              {/* Accordion Start - Budget */}
              <div className="container accordion-container doc-accordion">
                <div className="accordion" id="BudgetDocsAccordion">
                  {/* Item Start */}
                  <div className="stacked-accordion">
                    <h2 className="accordion-header">
                      <button className="accordion-button caret-off collapsed bgwhite-textblack-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapseBudgetDocs">
                        <div className="archivebox"></div>
                        <div>
                          <b className="accordion-title">Budgets</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapseBudgetDocs" className="accordion-collapse collapse" data-bs-parent="#BudgetDocsAccordion">
                      <div className="accordion-body-no-sides">
                        <BudgetsEntries />
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                </div>
              </div>
              {/* Accordion Finish - Budget */}

              {/*Accordion Start - Code */}
              <div className="container accordion-container doc-accordion">
                <div className="accordion" id="CodeDocsAccordion">
                  {/* Item Start */}
                  <div className="stacked-accordion">
                    <h2 className="accordion-header">
                      <button className="accordion-button caret-off collapsed bgwhite-textblack-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapseCodeDocs">
                        <div className="archivebox"></div>
                        <div>
                          <b className="accordion-title">Code Enforcement</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapseCodeDocs" className="accordion-collapse collapse" data-bs-parent="#CodeDocsAccordion">
                      <div className="accordion-body-no-sides">
                        <CodeEnforcementEntries />
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                </div>
              </div>
              {/* Accordion Finish - Code */}

              {/*Accordion Start - EAC */}
              <div className="container accordion-container doc-accordion">
                <div className="accordion" id="EACDocsAccordion">
                  {/* Item Start */}
                  <div className="stacked-accordion">
                    <h2 className="accordion-header">
                      <button className="accordion-button caret-off collapsed bgwhite-textblack-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEACDocs">
                        <div className="archivebox"></div>
                        <div>
                          <b className="accordion-title">Environmental Advisory Council</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapseEACDocs" className="accordion-collapse collapse" data-bs-parent="#EACDocsAccordion">
                      <div className="accordion-body-no-sides">
                        <div>
                          <EACEntries />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                </div>
              </div>
              {/* Accordion Finish - EAC */}

              {/*Accordion Start - Event Flyers */}
              <div className="container accordion-container doc-accordion">
                <div className="accordion" id="EventDocsAccordion">
                  {/* Item Start */}
                  <div className="stacked-accordion">
                    <h2 className="accordion-header">
                      <button className="accordion-button caret-off collapsed bgwhite-textblack-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEventDocs">
                        <div className="archivebox"></div>
                        <div>
                          <b className="accordion-title">Event Flyers</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapseEventDocs" className="accordion-collapse collapse" data-bs-parent="#EventDocsAccordion">
                      <div className="accordion-body-no-sides">
                        <EventFlyersEntries />
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                </div>
              </div>
              {/* Accordion Finish - Event Flyers */}

              {/*Accordion Start - Information */}
              <div className="container accordion-container doc-accordion">
                <div className="accordion" id="InfoDocsAccordion">
                  {/* Item Start */}
                  <div className="stacked-accordion">
                    <h2 className="accordion-header">
                      <button className="accordion-button caret-off collapsed bgwhite-textblack-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapseInfoDocs">
                        <div className="archivebox"></div>
                        <div>
                          <b className="accordion-title">Information (General)</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapseInfoDocs" className="accordion-collapse collapse" data-bs-parent="#InfoDocsAccordion">
                      <div className="accordion-body-no-sides">
                        <InfoEntries />
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                </div>
              </div>
              {/* Accordion Finish - Information */}
            </div>
            {/*End Left Side Of Page*/}

            {/*Start Right Side of Page*/}
            <div className="mb-960-col-50p">
              <br />
              {/*Accordion Start - Newsletters */}
              <div className="container accordion-container doc-accordion">
                <div className="accordion" id="NewslettersDocsAccordion">
                  {/* Item Start */}
                  <div className="stacked-accordion">
                    <h2 className="accordion-header">
                      <button className="accordion-button caret-off collapsed bgwhite-textblack-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapseNewslettersDocs">
                        <div className="archivebox"></div>
                        <div>
                          <b className="accordion-title">Newsletters</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapseNewslettersDocs" className="accordion-collapse collapse" data-bs-parent="#NewslettersDocsAccordion">
                      <div className="accordion-body-no-sides">
                        <NewslettersEntries />
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                </div>
              </div>
              {/* Accordion Finish - Newsletters */}

              {/*Accordion Start - Notices */}
              <div className="container accordion-container doc-accordion">
                <div className="accordion" id="NoticeDocsAccordion">
                  {/* Item Start */}
                  <div className="stacked-accordion">
                    <h2 className="accordion-header">
                      <button className="accordion-button caret-off collapsed bgwhite-textblack-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapseNoticeDocs">
                        <div className="archivebox"></div>
                        <div>
                          <b className="accordion-title">Notices</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapseNoticeDocs" className="accordion-collapse collapse" data-bs-parent="#NoticeDocsAccordion">
                      <div className="accordion-body-no-sides">
                        <NoticesEntries />
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                </div>
              </div>
              {/* Accordion Finish - Notices */}

              {/*Accordion Start - Planning */}
              <div className="container accordion-container doc-accordion">
                <div className="accordion" id="PlanningDocsAccordion">
                  {/* Item Start */}
                  <div className="stacked-accordion">
                    <h2 className="accordion-header">
                      <button className="accordion-button caret-off collapsed bgwhite-textblack-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapsePlanningDocs">
                        <div className="archivebox"></div>
                        <div>
                          <b className="accordion-title">Planning Commission</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapsePlanningDocs" className="accordion-collapse collapse" data-bs-parent="#PlanningDocsAccordion">
                      <div className="accordion-body-no-sides">
                        <div>
                        <PCEntries />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                </div>
              </div>
              {/* Accordion Finish - Planning */}

              {/*Accordion Start - Press Releases */}
              <div className="container accordion-container doc-accordion">
                <div className="accordion" id="PressDocsAccordion">
                  {/* Item Start */}
                  <div className="stacked-accordion">
                    <h2 className="accordion-header">
                      <button className="accordion-button caret-off collapsed bgwhite-textblack-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapsePressDocs">
                        <div className="archivebox"></div>
                        <div>
                          <b className="accordion-title">Press Releases</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapsePressDocs" className="accordion-collapse collapse" data-bs-parent="#PressDocsAccordion">
                      <div className="accordion-body-no-sides">
                        <PressReleaseEntries />
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                </div>
              </div>
              {/* Accordion Finish - Press Releases */}

              {/*Accordion Start - Road Programs */}
              <div className="container accordion-container doc-accordion">
                <div className="accordion" id="RoadProgramsAccordion">
                  {/* Item Start */}
                  <div className="stacked-accordion">
                    <h2 className="accordion-header">
                      <button className="accordion-button caret-off collapsed bgwhite-textblack-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapseRoadPrograms">
                        <div className="archivebox"></div>
                        <div>
                          <b className="accordion-title">Road Programs</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapseRoadPrograms" className="accordion-collapse collapse" data-bs-parent="#RoadProgramsAccordion">
                      <div className="accordion-body-no-sides">
                        <RoadProgramEntries />
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                </div>
              </div>
              {/* Accordion Finish - Road Programs */}

              {/*Accordion Start - Sanitation */}
              <div className="container accordion-container doc-accordion">
                <div className="accordion" id="SanitationDocsAccordion">
                  {/* Item Start */}
                  <div className="stacked-accordion">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button caret-off collapsed bgwhite-textblack-item button-full-width"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSanitationDocs"
                      >
                        <div className="archivebox"></div>
                        <div>
                          <b className="accordion-title">Sanitation</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapseSanitationDocs" className="accordion-collapse collapse" data-bs-parent="#SanitationDocsAccordion">
                      <div className="accordion-body-no-sides">
                        <SanitationEntries />
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                </div>
              </div>
              {/* Accordion Finish - Sanitation */}

              {/*Accordion Start - Stormwater */}
              <div className="container accordion-container doc-accordion">
                <div className="accordion" id="StormwaterDocsAccordion">
                  {/* Item Start */}
                  <div className="stacked-accordion">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button caret-off collapsed bgwhite-textblack-item button-full-width"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseStormwaterDocs"
                      >
                        <div className="archivebox"></div>
                        <div>
                          <b className="accordion-title">Stormwater Management</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapseStormwaterDocs" className="accordion-collapse collapse" data-bs-parent="#StormwaterDocsAccordion">
                      <div className="accordion-body-no-sides">
                       <StormwaterEntries />
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                </div>
              </div>
              {/* Accordion Finish - Stormwater */}

              {/*Accordion Start - ZHB */}
              <div className="container accordion-container doc-accordion">
                <div className="accordion" id="ZHBDocsAccordion">
                  {/* Item Start */}
                  <div className="stacked-accordion">
                    <h2 className="accordion-header">
                      <button className="accordion-button caret-off collapsed bgwhite-textblack-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapseZHBDocs">
                        <div className="archivebox"></div>
                        <div>
                          <b className="accordion-title">Zoning Hearing Board</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapseZHBDocs" className="accordion-collapse collapse" data-bs-parent="#ZHBDocsAccordion">
                      <div className="accordion-body-no-sides">
                        <ZHBEntries />
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                </div>
              </div>
              {/* Accordion Finish - ZHB */}
            </div>
            {/*End Right Side of Page*/}
          </div>
          <div className="page-footer bottom-cap-outlines">&nbsp;</div>
          <div className="gap-spacer"></div>
          <div className="gap-spacer"></div>
        </div>
      </div>
    </div>
  );
}
